import CampaignPostSearchPartial from "../../partials/campaign/campaign-posts-search.partial";

export default function CampaignPostsSearchScreen() {
  return <CampaignPostSearchPartial />;
}
